module.exports = __webpack_public_path__ + "static/img/Inspection13.817a278c.png";